<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" :label="label">
        <div class="col-12 q-mb-sm row gutter-sm">
            <div class="col-4">
                <q-input v-model="inputValue.lat"
                         :name="path"
                         type="number"
                         :color="color"
                         :disable="form.busy || disable"
                         :autofocus="autofocus"
                         :hide-underline="hideUnderline"
                         prefix="Lat:&nbsp;"
                         @input="onInput"></q-input>
            </div>
            <div class="col-4">
                <q-input v-model="inputValue.lng"
                         :name="path"
                         type="number"
                         :color="color"
                         :disable="form.busy || disable"
                         :hide-underline="hideUnderline"
                         prefix="Lng:&nbsp;"
                         @input="onInput"></q-input>
            </div>
            <div class="col-4">
                <div tabindex="-1"
                     class="q-if row no-wrap relative-position q-input q-if-standard q-if-has-content text-highlight">
                    <div class="q-if-baseline">|</div>
                    <div class="q-if-inner col column">
                        <div class="row no-wrap relative-position"><span
                                class="q-if-addon q-if-addon-left q-if-addon-visible">{{ $T('search') }}:&nbsp;</span>
                            <gmap-autocomplete value="España"
                                               class="col q-input-target q-no-input-spinner ellipsis"
                                               @keypress.13.prevent=""
                                               @place_changed="setPlace"/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <GmapMap :center="inputValue"
                 :zoom="16"
                 map-type-id="roadmap"
                 style="width: 100%; height: 400px"
                 @click="setPlaceFrom">
            <GmapMarker :position="inputValue"
                        :draggable="true"
                        @dragend="setPlaceFrom"/>
        </GmapMap>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QInput} from 'quasar-framework'

    export default {
        name: 'VCoords',

        mixins,

        data() {
            return {
                geoCoder: null,
                inputValue: this.value ? this.value : {lat: 38.70476850705958, lng: -9.175282716751099}
            }
        },

        mounted() {
            this.onInput()

            this.$gmapApiPromiseLazy(this.$gmapOptions)
                .then(() => this.$set(this, 'geoCoder', new google.maps.Geocoder()))
        },

        watch: {
            'form.address': 'updatePlaceFromAddress',
            'form.address_2': 'updatePlaceFromAddress',
            'form.city': 'updatePlaceFromAddress',
            'form.zipcode': 'updatePlaceFromAddress'
        },

        props: {
            type: {
                type: String,
                default: 'text'
            },
            minRows: {
                type: Number,
                default: 1
            },
            autofocus: Boolean,
            prefix: String
        },

        components: {
            QInput
        },

        methods: {
            setPlaceFrom(event) {
                this.inputValue = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                }

                this.onInput()
            },

            setPlace(place) {
                if (!place) return

                this.inputValue = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                }

                this.onInput()
            },

            updatePlaceFromAddress() {
                if (!!this.geoCoder &&
                    (this.form.address || this.form.address_2 || this.form.city || this.form.zipcode)) {
                    this.geoCoder.geocode({
                        address: this.form.address + ', ' + this.form.address_2 + ', ' +
                            this.form.city + ' ' + this.form.zipcode
                    }, (results, status) => {
                        if (status === 'OK' && results && results[0]) {
                            this.setPlace(results[0])
                        }
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VCoords.vue